<input type="file" name="imgc{{icCtrl.captureid}}" id="imgc{{icCtrl.captureid}}" class="inputfile"  accept="image/*;capture=camera" />
<label class="btn btn-primary" for="imgc{{icCtrl.captureid}}" uib-tooltip="Kamera oder Photo upload"><i class="fa fa-camera"></i> {{icCtrl.label || ''}}</label>
